import { useLanguageContext } from "../../../context/LanguageContext";
import BusinessCenterCompanyPage from "../../../pages/business_center_companies/business_center_company/BusinessCenterCompanyPage";
import { useBusinessCenterCompanyCreateRouteValidator } from "../../validators/business_center_companies/BusinessCenterCompanyCreateRouteValidator";
import { RouteConfig } from "../RouteConfig";
import useBusinessCenterCompaniesRouteConfig from "./BusinessCenterCompaniesRouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useBusinessCenterCompanyCreateRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/business_center_companies/create")
    .setLabel(
      translate("eva.main.entities.states.create", [
        {
          key: "entities",
          value: translate("eva.main.entities.business_center_company"),
        },
      ])
    )
    .setValidator(useBusinessCenterCompanyCreateRouteValidator())
    .setPage(<BusinessCenterCompanyPage />)
    .setParent(useBusinessCenterCompaniesRouteConfig());
}

export default useBusinessCenterCompanyCreateRouteConfig;
